import { Component, Match, Show, Switch } from 'solid-js';
import {
  BtnClasses,
  IconButton,
  PanelLayout,
  Spinner,
  WithLabel,
} from '@tcweb/connect-ui';
import { t } from '@trimble/i18n';
import { toMedDateTimeString } from '@trimble/date-utils';

export interface MissionDetailsProps {
  readonly name: string;
  readonly isLoading: boolean;
  readonly isError: boolean;
  readonly createdAt?: string;
  readonly createdBy?: string;
  readonly modifiedOn?: string;
  readonly modifiedBy?: string;
  onClose(): void;
}

export const MissionDetails: Component<MissionDetailsProps> = (props) => {
  return (
    <PanelLayout
      panelTitle={props.name}
      rightActions={
        <IconButton
          color={BtnClasses.TERTIARY}
          icon="tc-icon-content-close"
          size="icon-medium"
          data-cy="mission-details-close"
          clicked={() => props.onClose()}
        />
      }
      content={
        <div data-testid="mission-details" class="contents">
          <Switch>
            <Match when={props.isLoading}>
              <div
                data-testid="mission-details-spinner"
                class="w-full h-[300px]"
              >
                <Spinner show={true} />
              </div>
            </Match>
            <Match when={props.isError}>
              <div class="p-3" data-testid="mission-details-error">
                {t('general.error')}
              </div>
            </Match>
            <Match when={!props.isLoading && !props.isError}>
              <div class="flex flex-col p-3">
                <div data-testid="mission-details-title" class="h5">
                  {t('shared.ui.missionDetails.title')}
                </div>

                <Show when={props.createdAt} keyed>
                  {(value) => (
                    <WithLabel
                      label={t('shared.ui.missionDetails.createdAt')}
                      name=""
                    >
                      {toMedDateTimeString(new Date(value))}
                    </WithLabel>
                  )}
                </Show>

                <Show when={props.createdBy}>
                  <WithLabel
                    label={t('shared.ui.missionDetails.createdBy')}
                    name=""
                  >
                    {props.createdBy}
                  </WithLabel>
                </Show>

                <Show when={props.modifiedOn} keyed>
                  {(value) => (
                    <WithLabel
                      label={t('shared.ui.missionDetails.modifiedOn')}
                      name=""
                    >
                      {toMedDateTimeString(new Date(value))}
                    </WithLabel>
                  )}
                </Show>

                <Show when={props.modifiedBy}>
                  <WithLabel
                    label={t('shared.ui.missionDetails.modifiedBy')}
                    name=""
                  >
                    {props.modifiedBy}
                  </WithLabel>
                </Show>
              </div>
            </Match>
          </Switch>
        </div>
      }
    />
  );
};
